import { runTransaction } from "firebase/firestore";

function ehObjetoPlano(valor) {
  if (!valor || typeof valor !== "object" || Array.isArray(valor)) return false;
  const prototipo = Object.getPrototypeOf(valor);
  return prototipo === Object.prototype || prototipo === null;
}

export function valoresEquivalentes(valorA, valorB) {
  if (valorA === valorB) return true;

  if (Array.isArray(valorA) && Array.isArray(valorB)) {
    return (
      valorA.length === valorB.length &&
      valorA.every((item, index) => valoresEquivalentes(item, valorB[index]))
    );
  }

  if (ehObjetoPlano(valorA) && ehObjetoPlano(valorB)) {
    const chaves = new Set([...Object.keys(valorA), ...Object.keys(valorB)]);
    return [...chaves].every((chave) =>
      valoresEquivalentes(valorA[chave], valorB[chave])
    );
  }

  if (valorA instanceof Date && valorB instanceof Date) {
    return valorA.getTime() === valorB.getTime();
  }

  if (
    typeof valorA?.isEqual === "function" &&
    typeof valorB?.isEqual === "function"
  ) {
    return valorA.isEqual(valorB);
  }

  return false;
}

export function mesclarAlteracoesConcorrentes(original, local, remoto) {
  if (valoresEquivalentes(local, original)) return remoto;

  if (
    Array.isArray(original) &&
    Array.isArray(local) &&
    Array.isArray(remoto) &&
    original.length === local.length &&
    local.length === remoto.length
  ) {
    return local.map((item, index) =>
      mesclarAlteracoesConcorrentes(original[index], item, remoto[index])
    );
  }

  if (ehObjetoPlano(original) && ehObjetoPlano(local) && ehObjetoPlano(remoto)) {
    const resultado = {};
    const chaves = new Set([
      ...Object.keys(original),
      ...Object.keys(local),
      ...Object.keys(remoto),
    ]);

    chaves.forEach((chave) => {
      const valorMesclado = mesclarAlteracoesConcorrentes(
        original[chave],
        local[chave],
        remoto[chave]
      );
      if (valorMesclado !== undefined) resultado[chave] = valorMesclado;
    });

    return resultado;
  }

  return local;
}

export function extrairCamposAlterados(original = {}, atual = {}) {
  return Object.keys(atual).reduce((alteracoes, campo) => {
    if (!valoresEquivalentes(original?.[campo], atual[campo])) {
      alteracoes[campo] = atual[campo];
    }
    return alteracoes;
  }, {});
}

export async function atualizarDocumentoComMesclagem({
  db,
  referencia,
  original,
  atual,
  preparar = (dados) => dados,
  metadados = {},
}) {
  let dadosSalvos = null;

  await runTransaction(db, async (transacao) => {
    const snapshotAtual = await transacao.get(referencia);
    if (!snapshotAtual.exists()) {
      throw new Error("Documento não encontrado.");
    }

    const dadosMesclados = mesclarAlteracoesConcorrentes(
      original || {},
      atual || {},
      snapshotAtual.data()
    );
    dadosSalvos = {
      ...preparar(dadosMesclados),
      ...metadados,
    };

    transacao.update(referencia, dadosSalvos);
  });

  return dadosSalvos;
}
